export const SETTINGS_MODAL_FIELDS_NAME = {
    image_compress_max_size_webp: 'image_compress_max_size_webp',
    image_compress_quality: 'image_compress_quality',
    quality_compress_video: 'quality_compress_video',
    when_convert_delete_original_file: 'when_convert_delete_original_file'
}
